@switch (layoutVariant) {
  @case ('onePortalLayout') {
    <op-standard-layout></op-standard-layout>
  }
  @case ('legacySingleColumn') {
    <!-- legacy profile view -->
    <school-single-column-layout></school-single-column-layout>
  }
  @case ('fullScreen') {
    <!-- No layout wrapper: the routed page renders full-screen (pre-One-Portal data grid). -->
    <router-outlet></router-outlet>
  }
  <!-- will add more variants as we migrate more pages to one portal, for now we will just switch between legacySchoolStandardLayout and one portal layouts -->
  @default {
    <school-standard-layout></school-standard-layout>
  }
}
